import React from "react";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import { useI18n } from "../context/I18nContext";

const COMPANY = {
  name: "ITGuide SRL",
  email: "hello@it-guide.be",
  address: "35 boulevard du midi, B-6900 Marche-en-Famenne, Belgique",
  site: "corp-filter.it-guide.be",
};

const CONTENT = {
  mentions: {
    fr: {
      title: "Mentions légales",
      updated: "Dernière mise à jour : juin 2026",
      sections: [
        {
          h: "Éditeur du site",
          p: `Le présent site CORP-FILTER.EXE (${COMPANY.site}) est édité par ${COMPANY.name}, dont le siège social est situé ${COMPANY.address}.\nContact : ${COMPANY.email}`,
        },
        {
          h: "Responsable de la publication",
          p: `${COMPANY.name}, joignable à l'adresse ${COMPANY.email}.`,
        },
        {
          h: "Hébergement",
          p: "Le service est hébergé sur une infrastructure cloud conforme aux standards de sécurité de l'industrie. La base de données et les traitements sont opérés au sein de l'Union européenne dans la mesure du possible.",
        },
        {
          h: "Propriété intellectuelle",
          p: "L'ensemble des éléments du site (marque, charte graphique, textes, code) est la propriété exclusive de ITGuide SRL, sauf mention contraire. Toute reproduction non autorisée est interdite.",
        },
        {
          h: "Responsabilité",
          p: "CORP-FILTER.EXE est un outil d'assistance à la reformulation. L'utilisateur reste seul responsable du contenu qu'il saisit et des messages qu'il envoie à des tiers.",
        },
      ],
    },
    en: {
      title: "Legal Notice",
      updated: "Last updated: June 2026",
      sections: [
        {
          h: "Site publisher",
          p: `This website CORP-FILTER.EXE (${COMPANY.site}) is published by ${COMPANY.name}, registered office at ${COMPANY.address}.\nContact: ${COMPANY.email}`,
        },
        {
          h: "Publication manager",
          p: `${COMPANY.name}, reachable at ${COMPANY.email}.`,
        },
        {
          h: "Hosting",
          p: "The service is hosted on a cloud infrastructure compliant with industry security standards. Database and processing are operated within the European Union where possible.",
        },
        {
          h: "Intellectual property",
          p: "All site elements (brand, design, texts, code) are the exclusive property of ITGuide SRL unless stated otherwise. Any unauthorized reproduction is prohibited.",
        },
        {
          h: "Liability",
          p: "CORP-FILTER.EXE is a rephrasing assistance tool. The user remains solely responsible for the content they enter and the messages they send to third parties.",
        },
      ],
    },
    nl: {
      title: "Wettelijke vermeldingen",
      updated: "Laatst bijgewerkt: juni 2026",
      sections: [
        {
          h: "Uitgever van de site",
          p: `Deze website CORP-FILTER.EXE (${COMPANY.site}) wordt uitgegeven door ${COMPANY.name}, met maatschappelijke zetel te ${COMPANY.address}.\nContact: ${COMPANY.email}`,
        },
        {
          h: "Verantwoordelijke voor de publicatie",
          p: `${COMPANY.name}, bereikbaar op ${COMPANY.email}.`,
        },
        {
          h: "Hosting",
          p: "De dienst wordt gehost op een cloudinfrastructuur die voldoet aan de beveiligingsnormen van de sector. Database en verwerking worden waar mogelijk binnen de Europese Unie uitgevoerd.",
        },
        {
          h: "Intellectuele eigendom",
          p: "Alle elementen van de site (merk, vormgeving, teksten, code) zijn de exclusieve eigendom van ITGuide SRL, tenzij anders vermeld. Elke ongeoorloofde reproductie is verboden.",
        },
        {
          h: "Aansprakelijkheid",
          p: "CORP-FILTER.EXE is een hulpmiddel voor herformulering. De gebruiker blijft als enige verantwoordelijk voor de inhoud die hij invoert en de berichten die hij naar derden verstuurt.",
        },
      ],
    },
  },
  cgu: {
    fr: {
      title: "Conditions Générales d'Utilisation",
      updated: "Dernière mise à jour : juin 2026",
      sections: [
        {
          h: "1. Objet",
          p: "Les présentes CGU régissent l'utilisation du service CORP-FILTER.EXE, un outil en ligne qui reformule des messages bruts en communication professionnelle. En créant un compte, vous acceptez sans réserve ces conditions.",
        },
        {
          h: "2. Accès au service",
          p: "L'accès nécessite une authentification via Google. Le service propose un plan gratuit limité (10 traductions à vie, valable tant que le service reste en ligne) et des plans payants (Pro, Business) à paiement unique accordant 365 jours d'accès et un volume de traductions déterminé.",
        },
        {
          h: "3. Utilisation acceptable",
          p: "Vous vous engagez à ne pas utiliser le service à des fins illégales, diffamatoires, harcelantes ou contraires à l'ordre public. ITGuide SRL se réserve le droit de suspendre tout compte en cas d'abus.",
        },
        {
          h: "4. Abonnements et paiements",
          p: "Les paiements sont traités par Stripe. Les plans payants sont des achats uniques (non récurrents) accordant 365 jours d'accès : Pro (9,99 €, 100 traductions/an) et Business (19,99 €, 500 traductions/an). Aucun remboursement n'est dû une fois le service consommé, sauf disposition légale impérative.",
        },
        {
          h: "4 bis. Offre fondateur",
          p: "Les 5 premiers abonnés payants bénéficient d'une réduction de 25 % et les 5 suivants d'une réduction de 10 %, appliquée à vie sur leurs renouvellements. La mention « à vie » s'entend tant que le service CORP-FILTER.EXE reste en ligne ; ITGuide SRL peut modifier, suspendre ou arrêter cette offre et le service à tout moment, notamment en cas d'arrêt de l'exploitation.",
        },
        {
          h: "5. Parrainage",
          p: "Le programme de parrainage permet d'obtenir des bonus selon des règles précisées dans l'application. ITGuide SRL peut modifier ou suspendre ce programme à tout moment.",
        },
        {
          h: "6. Responsabilité",
          p: "Le service est fourni « en l'état ». ITGuide SRL ne garantit pas l'exactitude des reformulations générées par l'IA. L'utilisateur reste responsable de l'usage final des textes produits.",
        },
        {
          h: "7. Résiliation",
          p: "Vous pouvez cesser d'utiliser le service à tout moment. ITGuide SRL peut résilier l'accès en cas de violation des présentes CGU.",
        },
        {
          h: "8. Droit applicable",
          p: `Les présentes CGU sont soumises au droit belge. Pour toute question : ${COMPANY.email}.`,
        },
      ],
    },
    en: {
      title: "Terms of Service",
      updated: "Last updated: June 2026",
      sections: [
        {
          h: "1. Purpose",
          p: "These Terms govern the use of CORP-FILTER.EXE, an online tool that rephrases raw messages into professional communication. By creating an account, you fully accept these terms.",
        },
        {
          h: "2. Access",
          p: "Access requires Google authentication. The service offers a limited free plan (10 translations for life, valid as long as the service stays online) and paid one-time plans (Pro, Business) granting 365 days of access and a set translation volume.",
        },
        {
          h: "3. Acceptable use",
          p: "You agree not to use the service for any illegal, defamatory, harassing or public-order-violating purpose. ITGuide SRL may suspend any account in case of abuse.",
        },
        {
          h: "4. Subscriptions & payments",
          p: "Payments are processed by Stripe. Paid plans are one-time (non-recurring) purchases granting 365 days of access: Pro (€9.99, 100 translations/year) and Business (€19.99, 500 translations/year). No refund is due once the service is consumed, except where mandatory law applies.",
        },
        {
          h: "4 bis. Founder offer",
          p: 'The first 5 paying subscribers get a 25% discount and the next 5 a 10% discount, applied for life on their renewals. "For life" means as long as the CORP-FILTER.EXE service stays online; ITGuide SRL may modify, suspend or end this offer and the service at any time, including if operations cease.',
        },
        {
          h: "5. Referrals",
          p: "The referral program grants bonuses according to rules detailed in the app. ITGuide SRL may modify or suspend this program at any time.",
        },
        {
          h: "6. Liability",
          p: 'The service is provided "as is". ITGuide SRL does not guarantee the accuracy of AI-generated rephrasings. The user remains responsible for the final use of produced texts.',
        },
        {
          h: "7. Termination",
          p: "You may stop using the service at any time. ITGuide SRL may terminate access in case of breach of these Terms.",
        },
        {
          h: "8. Governing law",
          p: `These Terms are governed by Belgian law. For any question: ${COMPANY.email}.`,
        },
      ],
    },
    nl: {
      title: "Algemene Gebruiksvoorwaarden",
      updated: "Laatst bijgewerkt: juni 2026",
      sections: [
        {
          h: "1. Doel",
          p: "Deze voorwaarden regelen het gebruik van CORP-FILTER.EXE, een online tool die ruwe berichten herformuleert tot professionele communicatie. Door een account aan te maken, aanvaard je deze voorwaarden volledig.",
        },
        {
          h: "2. Toegang tot de dienst",
          p: "Toegang vereist authenticatie via Google. De dienst biedt een beperkt gratis plan (10 vertalingen voor het leven, geldig zolang de dienst online blijft) en betaalde eenmalige plannen (Pro, Business) die 365 dagen toegang en een bepaald aantal vertalingen verlenen.",
        },
        {
          h: "3. Aanvaardbaar gebruik",
          p: "Je verbindt je ertoe de dienst niet te gebruiken voor illegale, lasterlijke, intimiderende of de openbare orde verstorende doeleinden. ITGuide SRL behoudt zich het recht voor om elk account bij misbruik te schorsen.",
        },
        {
          h: "4. Abonnementen en betalingen",
          p: "Betalingen worden verwerkt door Stripe. Betaalde plannen zijn eenmalige (niet-terugkerende) aankopen die 365 dagen toegang verlenen: Pro (€ 9,99, 100 vertalingen/jaar) en Business (€ 19,99, 500 vertalingen/jaar). Er is geen terugbetaling verschuldigd zodra de dienst is verbruikt, behoudens dwingende wettelijke bepalingen.",
        },
        {
          h: "4 bis. Oprichtersaanbod",
          p: 'De eerste 5 betalende abonnees krijgen 25% korting en de volgende 5 krijgen 10% korting, voor het leven toegepast bij hun verlengingen. "Voor het leven" betekent zolang de dienst CORP-FILTER.EXE online blijft; ITGuide SRL kan dit aanbod en de dienst op elk moment wijzigen, opschorten of beëindigen, ook bij stopzetting van de exploitatie.',
        },
        {
          h: "5. Doorverwijzing",
          p: "Het doorverwijzingsprogramma verleent bonussen volgens regels die in de applicatie worden vermeld. ITGuide SRL kan dit programma op elk moment wijzigen of opschorten.",
        },
        {
          h: "6. Aansprakelijkheid",
          p: 'De dienst wordt geleverd "as is". ITGuide SRL garandeert niet de nauwkeurigheid van de door AI gegenereerde herformuleringen. De gebruiker blijft verantwoordelijk voor het uiteindelijke gebruik van de geproduceerde teksten.',
        },
        {
          h: "7. Beëindiging",
          p: "Je kunt het gebruik van de dienst op elk moment stopzetten. ITGuide SRL kan de toegang beëindigen bij schending van deze voorwaarden.",
        },
        {
          h: "8. Toepasselijk recht",
          p: `Deze voorwaarden zijn onderworpen aan het Belgische recht. Voor vragen: ${COMPANY.email}.`,
        },
      ],
    },
  },
  privacy: {
    fr: {
      title: "Politique de Confidentialité (RGPD)",
      updated: "Dernière mise à jour : juin 2026",
      sections: [
        {
          h: "1. Responsable du traitement",
          p: `${COMPANY.name}, ${COMPANY.address}, est responsable du traitement des données personnelles. Contact : ${COMPANY.email}.`,
        },
        {
          h: "2. Données collectées",
          p: "Nous collectons : votre email, nom et photo (via Google), votre plan d'abonnement, votre quota d'utilisation et les transactions de paiement. Les textes que vous soumettez à la traduction NE SONT PAS conservés après génération de la réponse.",
        },
        {
          h: "3. Finalités",
          p: "Les données sont utilisées pour : authentifier votre compte, fournir le service, gérer les abonnements et le parrainage, et envoyer des emails transactionnels (bienvenue, parrainage).",
        },
        {
          h: "4. Base légale",
          p: "Le traitement repose sur l'exécution du contrat (fourniture du service) et votre consentement pour les communications.",
        },
        {
          h: "5. Sous-traitants",
          p: "Nous utilisons : Google (authentification), Stripe (paiements), Resend (emails transactionnels) et un fournisseur d'IA (OpenAI) pour générer les reformulations. Ces prestataires sont engagés contractuellement à protéger vos données.",
        },
        {
          h: "6. Durée de conservation",
          p: "Les données de compte sont conservées tant que votre compte est actif. Les textes soumis ne sont pas stockés.",
        },
        {
          h: "7. Vos droits",
          p: `Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de portabilité et d'opposition. Pour exercer ces droits, contactez ${COMPANY.email}.`,
        },
        {
          h: "8. Cookies",
          p: "Nous utilisons un cookie de session strictement nécessaire à l'authentification. Aucun cookie publicitaire n'est déposé.",
        },
      ],
    },
    en: {
      title: "Privacy Policy (GDPR)",
      updated: "Last updated: June 2026",
      sections: [
        {
          h: "1. Data controller",
          p: `${COMPANY.name}, ${COMPANY.address}, is the controller of personal data. Contact: ${COMPANY.email}.`,
        },
        {
          h: "2. Data collected",
          p: "We collect: your email, name and picture (via Google), your subscription plan, usage quota and payment transactions. The texts you submit for translation ARE NOT stored after the response is generated.",
        },
        {
          h: "3. Purposes",
          p: "Data is used to: authenticate your account, provide the service, manage subscriptions and referrals, and send transactional emails (welcome, referral).",
        },
        {
          h: "4. Legal basis",
          p: "Processing is based on contract performance (service delivery) and your consent for communications.",
        },
        {
          h: "5. Processors",
          p: "We use: Google (authentication), Stripe (payments), Resend (transactional emails) and an AI provider (OpenAI) to generate rephrasings. These providers are contractually bound to protect your data.",
        },
        {
          h: "6. Retention",
          p: "Account data is kept while your account is active. Submitted texts are not stored.",
        },
        {
          h: "7. Your rights",
          p: `Under GDPR, you have the right to access, rectify, erase, port and object. To exercise these rights, contact ${COMPANY.email}.`,
        },
        {
          h: "8. Cookies",
          p: "We use a session cookie strictly necessary for authentication. No advertising cookie is set.",
        },
      ],
    },
    nl: {
      title: "Privacybeleid (AVG/GDPR)",
      updated: "Laatst bijgewerkt: juni 2026",
      sections: [
        {
          h: "1. Verwerkingsverantwoordelijke",
          p: `${COMPANY.name}, ${COMPANY.address}, is verantwoordelijk voor de verwerking van persoonsgegevens. Contact: ${COMPANY.email}.`,
        },
        {
          h: "2. Verzamelde gegevens",
          p: "Wij verzamelen: je e-mail, naam en foto (via Google), je abonnementsplan, je gebruiksquotum en betalingstransacties. De teksten die je ter vertaling aanbiedt, worden NIET bewaard nadat het antwoord is gegenereerd.",
        },
        {
          h: "3. Doeleinden",
          p: "Gegevens worden gebruikt om: je account te authenticeren, de dienst te leveren, abonnementen en doorverwijzingen te beheren en transactionele e-mails te versturen (welkom, doorverwijzing).",
        },
        {
          h: "4. Rechtsgrond",
          p: "De verwerking is gebaseerd op de uitvoering van de overeenkomst (levering van de dienst) en je toestemming voor communicatie.",
        },
        {
          h: "5. Verwerkers",
          p: "Wij gebruiken: Google (authenticatie), Stripe (betalingen), Resend (transactionele e-mails) en een AI-leverancier (OpenAI) om herformuleringen te genereren. Deze dienstverleners zijn contractueel verplicht je gegevens te beschermen.",
        },
        {
          h: "6. Bewaartermijn",
          p: "Accountgegevens worden bewaard zolang je account actief is. Aangeboden teksten worden niet opgeslagen.",
        },
        {
          h: "7. Jouw rechten",
          p: `Volgens de AVG heb je recht op inzage, rectificatie, wissing, overdraagbaarheid en bezwaar. Om deze rechten uit te oefenen, neem contact op via ${COMPANY.email}.`,
        },
        {
          h: "8. Cookies",
          p: "Wij gebruiken een sessiecookie die strikt noodzakelijk is voor authenticatie. Er wordt geen advertentiecookie geplaatst.",
        },
      ],
    },
  },
};

export default function Legal() {
  const { doc } = useParams();
  const { lang, t } = useI18n();
  const navigate = useNavigate();

  if (!CONTENT[doc]) {
    return <Navigate to="/legal/mentions" replace />;
  }
  const data = CONTENT[doc][lang] || CONTENT[doc].fr;

  return (
    <main className="flex-grow" data-testid={`legal-page-${doc}`}>
      <section className="max-w-3xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <button
          data-testid="legal-back-btn"
          onClick={() => navigate("/")}
          className="text-xs font-bold uppercase tracking-widest text-[#FF3B30] hover:underline mb-6"
        >
          ← {t("legal_back")}
        </button>
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#4B4B4B] font-bold mb-2">
          {data.updated}
        </p>
        <h1 className="font-display text-4xl sm:text-5xl uppercase leading-[0.95] tracking-tighter text-[#0A0A0A] mb-10">
          {data.title}
        </h1>
        <div className="flex flex-col gap-8">
          {data.sections.map((s, i) => (
            <div key={i} data-testid={`legal-section-${i}`}>
              <h2 className="font-display text-lg uppercase tracking-tight text-[#0A0A0A] mb-2 border-l-4 border-[#FFCC00] pl-3">
                {s.h}
              </h2>
              <p className="font-mono-corp text-sm text-[#4B4B4B] leading-relaxed whitespace-pre-line">
                {s.p}
              </p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
